import { render, staticRenderFns } from "./view-report.vue?vue&type=template&id=45cc2eda&"
import script from "./view-report.vue?vue&type=script&lang=ts&"
export * from "./view-report.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports